<template>
	<div>
		<div class="d-none d-sm-none d-md-block">
			<Navbar></Navbar>
		</div>

		<div class="d-none d-sm-none d-md-block">
			<GlobalSearch/>
		</div>

		<router-view></router-view>

    <div v-if="!['DiloConNieve', 'SubscriptionPayment', 'Subscriptions'].includes($route.name)" class="d-block d-sm-block d-md-none">
      <SwipeUpCart></SwipeUpCart>
    </div>

		<div class="d-none d-sm-none d-md-block">
			<Footer :categories_flavors="data_home_page.categories_flavors"></Footer>
		</div>

		<div class="d-block d-sm-block d-md-none">
			<FooterMobile/>
		</div>

    <div class="d-none d-sm-none d-md-block">
      <ButtonFloating />
    </div>

		<v-snackbar
			v-model="snackbar"
			timeout="-1"
			:left="left"
			color="accent"
			class="font-general-r"
      :top="top"
      :bottom="bottom"
		>
			<span v-if="number_day == 2">#MARTESDEPROMO</span>
      <span v-if="number_day == 4">#JUEVESDEPROMO</span>
			<template v-slot:action="{ attrs }">
				<v-btn
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Cerrar
				</v-btn>
			</template>
		</v-snackbar>

		<v-dialog
			v-model="open_cart"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar
					color="#fff"
					elevation="0"
				>
					<v-spacer></v-spacer>
					<v-btn
						icon
						@click="open_cart = false"
						class="mr-2"
					>
						<v-icon large color="accent">mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<Cart @closeModal="open_cart = false" :flavors="data_home_page.flavors"></Cart>

			</v-card>
		</v-dialog>

    <LoadingInit :open="dialog_init"/>

	</div>
</template>

<script>

window.addEventListener("scroll", function(){
	var navbar = document.getElementById("menu-nv");
  if (navbar) {
    navbar.classList.toggle("fixed-top", window.scrollY > 150)
    navbar.style.backgroundColor = '#fff8fc'
    navbar.style.marginTop = '0'
  }
})

import Navbar from '@/components/store/Navbar'
import Footer from '@/components/store/Footer'
import FooterMobile from '@/components/store/mobile/FooterMobile'
import HomeService from '@/services/home.service'
import Cart from '@/components/store/Cart'
import SwipeUpCart from '@/components/store/mobile/SwipeUpCart'
import ButtonFloating from '@/components/store/ButtonFloating'
import LoadingInit from '@/components/store/LoadingInit'

import { mapState } from 'vuex'
export default {
	name: 'StoreLayout',
	components: {
		Footer,
		FooterMobile,
		Navbar,
    Cart,
    SwipeUpCart,
    ButtonFloating,
    LoadingInit
	},
	data: () => ({
		fab: false,
		cart_fab: false,
		open_modal_phone: false,
		snackbar: false,
    open_cart: false,
    top: false,
    bottom: true,
    left: true,
    right: false,
    dialog_init: false
	}),
	computed: {
		...mapState(['number_day', 'cart', 'data_home_page'])
	},
	methods: {
		async getUser() {
			try {
				const { data:res } = await HomeService.me()
				if (res.success) {
					this.$store.dispatch('setUser', res.data)
				}
        if (this.$route.name != 'ConfirmationBuy') {
          this.$store.dispatch('setCart')
        }
			} catch (error) {
				this.$store.dispatch('setCart')
			}
		},
		async getDataHome() {
      if (this.$route.name != 'ConfirmationBuy') {
        this.dialog_init = true
        const { data:res } = await HomeService.getDataHomePage()
        await this.$store.dispatch('setDataHomePage', res)
        if (this.$route.name === 'Subscriptions' && !res.config_general.enabled_subscriptions) {
          this.$router.push({ name: 'Home' })
        }
        this.dialog_init = false
      }
		}
	},
	mounted() {
    setTimeout(() => {
      if (this.number_day == 2 || this.number_day == 4) {
        this.snackbar = true
      }
    }, 1000)

    let width = screen.width

    if (width <= 768) {
      this.top = true
      this.bottom = false
      this.left = false
      this.right = true
    }

	},
	created() {
		this.getUser()
		this.getDataHome()
	}
}
</script>

<style scoped>
	@import '../assets/css/styles.css';
	@import '../assets/css/icons.css';

	#create .v-speed-dial {
		position: absolute;
	}

	#create .v-btn--floating {
		position: relative;
	}
	>>>.v-dialog {
		box-shadow: none
	}
</style>
